import { __awaiter, __generator } from "tslib";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Amplify from 'aws-amplify';
import CognitoService from './CognitoService';
var AuthService = /** @class */ (function () {
    function AuthService() {
        var provider = globalThis.A6YReactAuthConfig.provider.type;
        switch (provider) {
            default:
                Amplify.configure({
                    Auth: {
                        region: globalThis.A6YReactAuthConfig.provider.region,
                        userPoolId: globalThis.A6YReactAuthConfig.provider.userPoolId,
                        userPoolWebClientId: globalThis.A6YReactAuthConfig.provider.userPoolWebClientId,
                    },
                });
        }
    }
    AuthService.signIn = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CognitoService.signIn(email, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthService.socialSignIn = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CognitoService.socialLogin(data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthService.signUp = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CognitoService.signUp(email, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthService.confirmSignUp = function (email, code) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CognitoService.confirmSignUp(email, code)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthService.socialSignUp = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CognitoService.socialLogin(data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthService.forgotPassword = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CognitoService.forgotPassword(email)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthService.forgotPasswordSubmit = function (user, code, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CognitoService.forgotPasswordSubmit(user, code, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthService.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CognitoService.signOut()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AuthService;
}());
export default AuthService;
//# sourceMappingURL=AuthService.js.map